import { Stack, styled } from '@mui/material';

export const StyledMaxWidthStack = styled(Stack)(({ theme }) => ({
  margin: 'auto',
  maxWidth: theme.spacing(100) // desired outcome: 400px
}));
